export default "__VITE_ASSET__ciXSwwHV__"